import papaparse from 'papaparse';
import set from 'lodash/set';
import { CSV_HEADER_FIELDS } from 'pages/CreateCompanionAssessment/constant';

export const useParseCsv = ({ headerSchema, rowSchema, transformRow }) => {

  const validateHeader = async (header) => {
    try {
      await headerSchema.validate(header, { abortEarly: false });
      return true;
    } catch (error) {
      let err = {};
      error.inner?.forEach((e) => {
        err[e.path] = e.message;
      });
      return err;
    }
  };

  const validateRows = async (rows) => {
    const result = await Promise.all(
      rows.map(async (row, idx) => {
        try {
          await rowSchema.validate(row, { abortEarly: false, context: { rowIndex: idx } });
          return true;
        } catch (error) {
          let err = { rowIndex: idx };
          error.inner?.forEach((e) => {
            err[e.path] = e.message;
          });
          return err;
        }
      })
    );

    return result;
  };

  return (file) => {
    return new Promise((resolve) => {
      let returnObj = {};
      if (file.type !== 'text/csv') {
        resolve(false);
      } else {
        papaparse.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: async (results) => {
            const list = results.data.map((row) => {
              let obj = {};
              Object.keys(row).forEach((key, idx) => {
                obj[CSV_HEADER_FIELDS[idx]] = row[key];
              });
              if (transformRow) obj = transformRow(obj);
              return obj;
            });
            returnObj = {
              headers: results.data.length > 0 ? Object.keys(results.data[0]) : [],
              list: list.map((row) => {
                Object.keys(row).forEach((k) => (row[k] = row[k]?.trim()));
                return row;
              }), // trim spaces all values
            };

            const headerValidation = await validateHeader(returnObj.headers);
            const rowValidation = await validateRows(returnObj.list);

            if (headerValidation !== true || rowValidation.some((row) => row !== true)) {
              if (headerValidation !== true) set(returnObj, 'status.headers', headerValidation);
              if (rowValidation.some((row) => row !== true)) set(returnObj, 'status.rows', rowValidation);
            }

            resolve(returnObj);
          },
        });
      }
    });
  };
};
